var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSlackIconWithBackground48X48 = function SvgSlackIconWithBackground48X48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#4A154B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#slack-icon-with-background_48x48_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.997 27.638c0 1.61-1.3 2.91-2.91 2.91s-2.91-1.3-2.91-2.91 1.3-2.91 2.91-2.91h2.91v2.91Zm1.455 0c0-1.61 1.3-2.91 2.91-2.91s2.91 1.3 2.91 2.91v7.275c0 1.61-1.3 2.91-2.91 2.91s-2.91-1.3-2.91-2.91v-7.275Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.362 15.953c-1.61 0-2.91-1.301-2.91-2.91 0-1.61 1.3-2.91 2.91-2.91s2.91 1.3 2.91 2.91v2.91h-2.91Zm0 1.477c1.61 0 2.91 1.3 2.91 2.91s-1.3 2.91-2.91 2.91h-7.297c-1.61 0-2.91-1.3-2.91-2.91s1.3-2.91 2.91-2.91h7.297Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.025 20.34c0-1.61 1.301-2.91 2.91-2.91 1.61 0 2.91 1.3 2.91 2.91s-1.3 2.91-2.91 2.91h-2.91v-2.91Zm-1.455 0c0 1.61-1.3 2.91-2.91 2.91s-2.91-1.3-2.91-2.91v-7.297c0-1.61 1.3-2.91 2.91-2.91s2.91 1.3 2.91 2.91v7.297Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.66 32.003c1.61 0 2.91 1.3 2.91 2.91s-1.3 2.91-2.91 2.91-2.91-1.3-2.91-2.91v-2.91h2.91Zm0-1.455c-1.61 0-2.91-1.3-2.91-2.91s1.3-2.91 2.91-2.91h7.298c1.609 0 2.91 1.3 2.91 2.91s-1.301 2.91-2.91 2.91H27.66Z",
    fill: "#ECB22E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "slack-icon-with-background_48x48_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 10)",
    d: "M0 0h28v28H0z"
  })))));
};

export default SvgSlackIconWithBackground48X48;